import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  // ButtonBase,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import img from "./cardImg.png";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
// import Subscription from ".F/Subscription";
import { useDispatch, useSelector } from "react-redux";
// import DaynmicObj from "./DaynmicObj";
// import { add } from "store/Reducers/cartSlice";
import { add_Addons, updateAddOnCount, updateCount } from "store/Reducers/AddonsSlice";
const data = [
  {
    id: 1,
    title: "Main Course",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "block",
    incDecBtnProp: "flex",
    subTitleProp: "block",
    selectBtnProp: "block",
  },
  {
    id: 2,
    title: "Slide",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "none",
    incDecBtnProp: "none",
    subTitleProp: "block",
    // selectBtnProp: "none",
  },
  {
    id: 3,
    title: "Juice",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "block",
    incDecBtnProp: "flex",
    subTitleProp: "block",
    selectBtnProp: "block",
  },
];
const AddOne = () => {

  const { selectedAddon } = useSelector((state) => state.addOns)
  console.log("selectedAddons", selectedAddon)

  const dispatch = useDispatch();
  const [showIncDec, setshowIncDec] = useState([]);

  const ShowIncDec = (id) => {
    console.log(id);
    const clickedObj = data.filter((v) => v.id === id);
    const clickedObj1 = data.filter((v) => v.id === id);
    console.log("clickedObj", clickedObj1[0])
    setshowIncDec(clickedObj);
    console.log(showIncDec);
    // console.log(showIncDec[0].id);
    setTimeout(() => {

      if (clickedObj) {
        dispatch(add_Addons(clickedObj[0]))
      } else {
        console.log("nhi ho skta bhai ")
      }
    }, 1000);

  };


  const getInc = (addOn) => {
    console.log("addOn", addOn);
    dispatch(add_Addons(addOn))
    console.log("selectedAddons", selectedAddon)
  };




  const getDec = (AddOn) => {
    // console.log("addOn", AddOn);
    // if()
    const filterAddOn = selectedAddon.filter((addOn) => addOn.addOn.id === AddOn.id)
    // console.log("filterAddOn", filterAddOn);

    if (filterAddOn[0].quantity > 1) {
      dispatch(updateAddOnCount(AddOn))
    }

  }

  return (
    <>
      <Box>
        <Box sx={{ margin: { lg: "30px", md: "20px", sm: "20px", xs: "0px" } }}>
          <Box sx={{ mb: "20px" }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "32px",
              }}
            >
              Add-ons
            </Typography>
          </Box>
          <Grid container spacing={3}>
            {data &&
              data.map((v, i) => {
                return (
                  <>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Box>
                          <img src={img} />
                        </Box>
                        <Box>
                          <Box sx={{ ml: "10px" }}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "20px",
                              }}
                            >
                              {v?.title}
                            </Typography>
                            {selectedAddon?.map((addOn) => {
                              return (
                                <>
                                  {addOn?.addOn?.id === v?.id && (
                                    <Typography
                                      sx={{
                                        color: "#545359",
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        display: `block`,
                                        // border: "1px solid red"
                                      }}
                                    >
                                      {addOn.quantity}  {" "}
                                      Selected
                                    </Typography>
                                  )}
                                </>
                              )
                            })}
                          </Box>

                          {showIncDec.length > 0 &&
                            showIncDec[0].id === v.id ? (
                            <Box
                              sx={{
                                display: `flex`,
                                flexDirection: "row",
                                alignItems: "center",
                                ml: "10px",
                                mt: "5px",
                              }}
                            >
                              <Box>
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F0FAF9",
                                  }}
                                  onClick={() => getDec(showIncDec[0])}
                                >
                                  <RemoveIcon sx={{ color: "#2B817B" }} />
                                </IconButton>
                              </Box>
                              <Box sx={{ ml: "11px", mr: "11px" }}>
                                {/* <Typography> */}
                                {selectedAddon.map((addOn) => {
                                  return (
                                    <>
                                      {addOn?.addOn?.id === v?.id && (
                                        <Typography
                                          sx={{
                                            color: "#545359",
                                            fontWeight: "bold",
                                            fontSize: "15px",
                                            display: `block`,
                                            // border: "1px solid red"
                                          }}
                                        >
                                          {addOn.quantity}
                                        </Typography>
                                      )}
                                    </>
                                  )
                                })}
                                {/* </Typography> */}
                              </Box>
                              <Box>
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F0FAF9",
                                  }}
                                  onClick={() => getInc(showIncDec[0])}
                                >
                                  <AddIcon sx={{ color: "#2B817B" }} />
                                </IconButton>
                              </Box>
                            </Box>
                          ) : (
                            <Box sx={{ ml: "10px", mt: "30px" }}>
                              <Button
                                variant="outlined"
                                sx={{ display: `${v.selectBtnProp} ` }}
                                onClick={() => ShowIncDec(v.id)}
                              >
                                Select Dishes
                              </Button>
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ ml: "10px", display: `${v.EditbtnProp} ` }}>
                          <Button variant="text">Edit</Button>
                        </Box>
                      </Box>
                    </Grid >
                  </>
                );
              })}
          </Grid>
        </Box>
      </Box >

    </>
  );
};

export default AddOne;
